import { Component } from '@angular/core';
import { UUID } from 'angular2-uuid';
import { NavParams, Platform, ViewController } from 'ionic-angular';
import { Lookup } from '../../../business-objects/lookup/lookup.model';
import { RichTextEditor } from '../../../helpers/rich-text-editor';
import { RichTextModalArgs } from './rich-text-control-modal-args.model';

@Component({
    selector: '',
    templateUrl: './rich-text-control-modal.component.html'
})
export class RichTextControlModalComponent {

    args: RichTextModalArgs;
    value: string = '';
    title: string;
    textBlockPickerVisible = false;
    editorId: string = UUID.UUID();
    richTextEditor: RichTextEditor = new RichTextEditor();

    constructor(
        public platform: Platform,
        public params: NavParams,
        public viewCtrl: ViewController
    ) {
        this.args = this.params.data;
        this.title = this.args.getTitle() || 'Edit';
        this.value = this.args.getValue();
    }

    ngAfterViewInit(): void {
        this.richTextEditor.init(`#${this.editorId}`);
    }

    ngOnDestroy(): void {
        this.richTextEditor.destroy();
    }

    get textBlockLookupTypeId(): string {
        return this.args.getTemplateLookupTypeId();
    }

    onSave(): void {
        this.dismiss(this.richTextEditor.content);
    }

    onCancel(): void {
        this.dismiss(this.args.getValue());
    }

    onToggleTemplatePicker(): void {
        this.textBlockPickerVisible = !this.textBlockPickerVisible;
    }

    onResetToDefault(): void {
        this.dismiss(this.args.getDefaultValue());
    }

    onPickTextBlock(item: Lookup): void {
        this.richTextEditor.insertContent(item.content);
    }

    dismiss(params?): void {
        this.viewCtrl.dismiss(params);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/rich-text/form/rich-text-control-modal.component.ts